import Store from '@/utils/localStore';

export default {
  created() {
    this.query.pageSize = Store.get('pageSize') ? Store.get('pageSize') : 20;
  },
  computed: {
    pageSize() {
      return this.query.pageSize;
    },
  },
  watch: {
    pageSize(newValue) {
      Store.set('pageSize', newValue);
    },
  },
};
